"use client";

import { browserRouterAdapter } from "./router/adapters/browser";
import type { RouterAdapter } from "./router/adapter";

export { getStoreConfig, setStoreConfig } from "./storage/config";

// TODO: move out
interface RouterConfig {
  routerAdapter: RouterAdapter;
}
const routerConfig: RouterConfig = {
  routerAdapter: browserRouterAdapter(),
};

export const getRouterConfig = () => routerConfig;

export const setRouterConfig = (config: Partial<RouterConfig>) => {
  Object.entries(config).forEach(([key, value]) => {
    if (key in routerConfig) {
      routerConfig[key as keyof RouterConfig] = value;
    }
  });
};
